import { Routes } from '@angular/router';
import { authGuard } from './guards/auth.guard';
import { LoginComponent } from './components/login/login.component';
import { HomeComponent } from './components/home/home.component';
import { SetupComponent } from './components/setup/setup.component';
import { PracticeSessionComponent } from './components/practice-session/practice-session.component';

export const routes: Routes = [
    { path: '', redirectTo: '/home', pathMatch: 'full' },
    { path: 'login', component: LoginComponent },
    { path: 'home', component: HomeComponent, canActivate: [authGuard]},
    { path: 'setup', component: SetupComponent, canActivate: [authGuard]},
    { path: 'practice', component: PracticeSessionComponent, canActivate: [authGuard]}
];
